var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"Help"},[_vm._m(0),_c('div',{staticClass:"Help-box"},[_c('div',{staticClass:"Help-content"},[_c('router-link',{attrs:{"to":"/Home/MyMessage/announcement"}}),_c('router-view')],1)])])
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"header"},[_c('div',{staticClass:"header-text"},[_c('h2',[_vm._v("用户中心")])])])
}]

export { render, staticRenderFns }